import React, { useState } from "react";
import { Button, Flex, Box, Badge } from "@chakra-ui/react";
import { Plus } from "lucide-react";
import { useAppContext } from "../../contexts/AppContext";
import TasksTable from "./TasksTable";
import useTasks from "../../hooks/useTasks";

const PendingTasks = ({ openTaskDrawer }) => {
  const { tasks, remainingTasks } = useAppContext();
  const { handleCheckboxChange, justCompletedTasks } = useTasks();
  const [filters, setFilters] = useState({});

  return (
    <Flex direction="column" p={0} w={"100%"} gap={8}>
      <Flex
        justifyContent="space-between"
        direction={{ lg: "row", base: "column" }}
        gap={4}>
        <Flex align={"center"} gap={4}>
          <h1>Pending tasks</h1>
          {remainingTasks > 0 && (
            <Badge colorScheme="error" variant="solid" fontSize={"lg"}>
              {remainingTasks}
            </Badge>
          )}
        </Flex>
        <Flex gap={1}>
          <Button
            onClick={() => openTaskDrawer()}
            w={"fit-content"}
            leftIcon={<Plus size={16} />}>
            Add a new task
          </Button>
          
        </Flex>
      </Flex>

      {tasks.some((task) => !task.completed) ? (
        <TasksTable
          tasks={tasks.filter(
            (task) => !task.completed || justCompletedTasks.includes(task.id)
          )}
          filters={filters}
          setFilters={setFilters}
          handleCheckboxChange={handleCheckboxChange}
          justCompletedTasks={justCompletedTasks}
          onRowClick={(task) => openTaskDrawer(task)}
        />
      ) : (
        <Box textAlign="center" mt={4} color="gray.500">
          No active tasks
        </Box>
      )}
    </Flex>
  );
};

export default PendingTasks;
